import { Cindy, CindyButton, CindyTypography, useMediaQuery, useTheme } from '@ace-clublabs/shared-component-library';
import { useContext } from 'react';
import { MembershipAppStateContext } from './MembershipAppState/MembershipAppState';
import { ClubCode } from '@lib/types';

interface ContactSupportCardProps {
  styleOverrides?: object;
}
export const ContactSupportCard: (props: ContactSupportCardProps) => JSX.Element = ({ styleOverrides }) => {
  const { sessionData } = useContext(MembershipAppStateContext);
  const clubCode = sessionData?.clubCode;

  const theme = useTheme();
  const isMobileScreenSize = useMediaQuery(theme.breakpoints.down('lg'));

  const getAgentPhoneHours = (clubCode: string | undefined) => {
    switch (clubCode) {
      case ClubCode.calif:
        return 'Monday–Friday: 6 a.m. to 11 p.m. PST\nSaturday: 8 a.m. to 6 p.m. PST\nSunday: 8 a.m. to 4 p.m. PST';
      case ClubCode.texas:
        return 'Monday–Friday: 7 a.m. to 8 p.m. CST\nSaturday: 8 a.m. to 6 p.m. CST\nSunday: 10 a.m. to 2 p.m. CST';
      case ClubCode.autoclubmo:
        return 'Monday–Friday: 7 a.m. to 8 p.m. CST\nSaturday: 9 a.m. to 6 p.m. CST';
      case ClubCode.northernnewengland:
        return 'Monday–Friday: 7 a.m. to 7 p.m. EST\nSaturday: 9 a.m. to 5 p.m. EST';
      case ClubCode.newmexico:
        return 'Monday–Friday: 9 a.m. to 5 p.m. CST';
      case ClubCode.tidewater:
        return 'Monday–Friday: 9 a.m. to 5:30 p.m. EST\nSaturday: 9 a.m. to 1 p.m. EST';
      case ClubCode.hawaii:
        return 'Monday–Friday: 9 a.m. to 5 p.m. HST\nSaturday: 9 a.m. to 2 p.m. HST';
      case ClubCode.alabama:
        return 'Monday–Friday: 7:30 a.m. to 6 p.m. CST\nSaturday: 9 a.m. to 2 p.m. CST';
      case ClubCode.eastcentral:
        return 'Monday–Friday: 7 a.m. to 7 p.m. EST\nSaturday: 9 a.m. to 5 p.m. EST';
      default:
        return 'Monday–Friday: 7 a.m. to 9 p.m. \nSaturday: 8 a.m. to 5 p.m.';
    }
  };

  return (
    <Cindy
      sx={{
        marginTop: isMobileScreenSize ? '1rem' : '1.5rem',
        marginBottom: '1.5rem',
        '& .MuiGrid-root': {
          width: '100%',
        },
        ...styleOverrides,
      }}
      className="contact-support-card"
      text={
        <>
          <CindyTypography sx={{ fontSize: '0.875rem !important', fontWeight: 700 }}>
            Have questions before joining?
          </CindyTypography>
          <CindyTypography sx={{ fontSize: '0.875rem !important' }} className="contact-phone-hours">
            {getAgentPhoneHours(clubCode || '')}
          </CindyTypography>
        </>
      }
    >
      <CindyButton
        className="contact-phone-button"
        label="Call 1-888-703-0686"
        href={`tel:1-888-703-0686`}
        sx={{ fontSize: '0.875rem !important', marginTop: '.5rem' }}
      />
    </Cindy>
  );
};
